import React, {useState} from "react";
import {axiosInstance} from "../../config/http";
import {LeftLogoPane, Logos, PageWrapper, RightFormPane} from "../login/styled";
import iriLogo from "../../assets/IRI_logo.jpg";
import columbiaLogo from "../../assets/columbia_logo.png"
import {Button, InputBox} from "../../common/styled";

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [msg, setMsg] = useState('')

  const sendResetLink = async () => {
    setMsg('')
    try {
      const resp = await axiosInstance.post('/forgot_password', { email })
      setMsg(resp.data.msg)
    } catch (e) {
      setMsg('Something went wrong. Please try again.')
    }
  }

  return (
    <PageWrapper>
      <LeftLogoPane>
        <span>DESDR NOKi</span>
        <span>SURVEY YOUR WAY</span>
        <Logos>
          <img src={iriLogo} alt="IRI logo"/>
          <img src={columbiaLogo} alt="Columbia University logo"/>
        </Logos>
      </LeftLogoPane>
      <RightFormPane>
        <InputBox placeholder={'Enter your email'} type={'text'} onChange={(e) => setEmail(e.target.value)}
               value={email}/>
        <Button onClick={sendResetLink}>Send reset link</Button>
        {msg && <p style={{fontSize: '12px', marginTop: '5px'}}>{msg}</p>}
      </RightFormPane>
    </PageWrapper>
  )
}

export default ForgotPassword;